<template>
  <div class="terms-of-use h-full space-about">
    <VuePerfectScrollbar
      class="terms-of-user-scroll"
      :settings="settings"
      :suppressScrollX="true"
      @ps-y-reach-end="scrollHandleToEnd"
    >
      <div v-if="!canDisplayOnMobileIOS" class="terms-off-platform" v-html="$t('TERMS_USE').Text"></div>
      <div v-else class="terms-off-platform" v-html="$t('TERMS_USE').Text_Mobile"></div>
    </VuePerfectScrollbar>
    <div class="buttons-act mt-2 mb-2">
      <vs-button
        v-if="displayActionButton"
        type="border"
        @click="$emit('cancel')"
        class="mr-2"
        >{{$t('TERMS_USE').Cancel}}</vs-button
      >
        <!-- :disabled="disableButtonTermsCondition" -->
      <vs-button
        v-if="displayActionButton"
        type="filled"
        @click="$emit('accept-terms')"
        class="ml-1"
        >{{$t('TERMS_USE').Read_Accepted}}</vs-button
      >
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
  props: {
    displayActionButton: true
  },
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        swipeEasing: true,
      },
      disableButtonTermsCondition: true,
      perfectScrollbarReachEnd: false
    };
  },
  computed: {
    canDisplayOnMobileIOS() {
      return this.$store.state.isMobileIOS;
    },
  },
  mounted() {
    try {
      const backgroundDiv = document.createElement('div');
      backgroundDiv.className = 'popup-custom-background';
      document.getElementsByClassName('terms-condition-modal')[0].appendChild(backgroundDiv);
    } catch (error) {}
  },
  methods: {
    scrollHandleToEnd() {
      // console.log('scrollHandleToEnd');
      if (!this.perfectScrollbarReachEnd) {
        this.disableButtonTermsCondition = false;
        this.perfectScrollbarReachEnd = true;
      }
    },
  }
};
</script>

<style lang="scss">
  .terms-of-use {
    height: 100%;
    .terms-of-user-scroll {
      height: calc(100% - 100px);
    }
  }
</style>